<template>
    <main></main>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("destroyToken").then(response => {
      localStorage.removeItem('access_token')
      localStorage.removeItem('id_usuario_plataforma')
      window.location.href = "https://admin.generaideasia.com/login"
    });
  }
};
</script>